// src/pages/SupportImportSuccess.jsx
import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function SupportImportSuccess() {
  const { t } = useTranslation();

  return (
    <div className="max-w-xl mx-auto px-4 py-16 text-center">
      <h1 className="text-3xl font-serif mb-3">{t("supportImportSuccess.title")}</h1>
      <p className="text-gray-700">{t("supportImportSuccess.description")}</p>
      <Link className="btn-artsy btn-primary-artsy mt-6" to="/dashboard">
        {t("supportImportSuccess.dashboard")}
      </Link>
    </div>
  );
}
